import axios from "../axiosInstance"
import { PitchbookCompanyData, PitchbookInvestorData } from "@/types"

export const getPitchbookCompany = async (companyId: number): Promise<PitchbookCompanyData> => {
  try {
    const res = await axios.get(`/pitchbook/company/${companyId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch pitchbook data")
    }

    return data.data
  } catch (error) {
    console.error("Error fetching pitchbook data:", error)
    throw error
  }
}

export const syncPitchbookCompany = async (companyId: number) => {
  try {
    const res = await axios.post(`/pitchbook/sync/company/${companyId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to sync pitchbook data")
    }
    return data
  } catch (error) {
    console.error("Error syncing pitchbook data:", error)
    throw error
  }
}

export const getPitchbookInvestor = async (pbInvestorId: string): Promise<PitchbookInvestorData> => {
  try {
    const res = await axios.get(`/pitchbook/investor/${pbInvestorId}`)
    const { data } = res
    if (!data.success) {
      throw new Error(data.message || "Failed to fetch pitchbook investor data")
    }

    return data.data
  } catch (error) {
    console.error("Error fetching pitchbook investor data:", error)
    throw error
  }
}
